import React from 'react';
import experiment from 'experiment';
import * as util from '#packages/util';
import { translate } from '#packages/i18n';
import { Divider, TextLabel, Heading } from '@wix/wix-base-ui';
import styles from './header.scss';
import VideoTooltip from '../videoTooltip/videoTooltip';
import type { BiEventDefinition, BiEventFields } from 'types/bi';
import { getYoutubeUrl } from '../utils/youtubeVideoUrl';
import { MainActionItems } from '../actionItems/mainActionItems';

interface WelcomePageHeaderProps {
  canEditSiteStructure: boolean;
  canSaveSchemas: boolean;
  isFirstTimeExperience: boolean;
  openAddPresetPanel: () => void;
  openCreateCollectionPanel: () => void;
  openVideoPanel: (videoId: string, isEmptyState: boolean) => void;
  sendBi: (event: BiEventDefinition, params: BiEventFields) => void;
  openHelpCenter: (articleId: string) => void;
  onSettingsIconClick: (actionName: string, isEmptyState: boolean) => void;
}

const newCmsPanelTitleOpen = experiment.isOpen(
  'specs.wixDataClient.newCmsPanelTitle',
);

const getSubtitle = () => {
  return newCmsPanelTitleOpen
    ? translate('CONTENT_MANAGER_6_BUTTON_MAIN_SUBTITLE_V2')
    : translate('CONTENT_MANAGER_6_BUTTON_MAIN_SUBTITLE');
};

const WelcomePageHeader: React.FC<WelcomePageHeaderProps> = ({
  canEditSiteStructure,
  canSaveSchemas,
  isFirstTimeExperience,
  openAddPresetPanel,
  openCreateCollectionPanel,
  openVideoPanel,
  sendBi,
  openHelpCenter,
}) => (
  <div
    className={[styles.welcomePageHeader]
      .concat(isFirstTimeExperience ? styles.isFirstTimeExperience : [])
      .join(' ')}
  >
    <div className={styles.actionsContainer}>
      <VideoTooltip
        openVideoPanel={() => {
          openVideoPanel(
            translate('CONTENT_MANAGER_6_BUTTON_MAIN_MENU_TOOLTIP_VIDEO_ID'),
            isFirstTimeExperience,
          );
        }}
        title="CONTENT_MANAGER_6_BUTTON_MAIN_MENU_TOOLTIP_VIDEO_TITLE"
        subtitle="CONTENT_MANAGER_6_BUTTON_MAIN_MENU_TOOLTIP_VIDEO_SUBTITLE"
        altText="CONTENT_MANAGER_6_BUTTON_MAIN_MENU_TOOLTIP_VIDEO_ALT_TEXT"
        imageUrl={
          'addPanelData/sections/dataBinding/contentManagerVideoThumbnail.png'
        }
        videoUrl={getYoutubeUrl(
          translate('CONTENT_MANAGER_6_BUTTON_MAIN_MENU_TOOLTIP_VIDEO_ID'),
        )}
        isEmptyState={isFirstTimeExperience}
        sendBi={sendBi}
        tabName="main"
      />
    </div>

    <div className={styles.info}>
      <img
        className={styles.illustration}
        src={util.media.getMediaUrl(
          'addPanelData/sections/dataBinding/contentManager.png',
        )}
        alt=""
      />
      <Heading multiline={false} shouldTranslate={false} appearance="h3">
        {translate('CONTENT_MANAGER_6_BUTTON_MAIN_TITLE')}
      </Heading>
      <div>
        <TextLabel
          type="T02"
          value={getSubtitle()}
          className={styles.description}
          enableEllipsis={false}
          shouldTranslate={false}
        />
      </div>
    </div>
    <Divider />
    <MainActionItems
      canEditSiteStructure={canEditSiteStructure}
      canSaveSchemas={canSaveSchemas}
      isFirstTimeExperience={isFirstTimeExperience}
      openAddPresetPanel={openAddPresetPanel}
      openCreateCollectionPanel={openCreateCollectionPanel}
      openHelpCenter={openHelpCenter}
      sendBi={sendBi}
    />
  </div>
);

export default WelcomePageHeader;
